export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v3-detail-c3be1f91e35f509640625eaedf327f0b.png";